import {
  DocumentReference,
  isDocRef,
  isISODateType,
  ISODateType,
  TypeGuard,
} from '@principle-theorem/shared';
import { isBoolean, isString, isNumber } from 'lodash';
import { Gender, IPatient } from '../../patient/patient';
import { IPractice } from '../../practice/practice';

export interface IMohGenerateEnrolmentFormRequest {
  patient: DocumentReference<IPatient>;
  practice: DocumentReference<IPractice>;
  data: IMohEnrolmentData;
}

export enum MohEnrolmentSignatureType {
  Typed = 'typed',
  Drawn = 'drawn',
  NotProvided = 'notProvided',
}

export interface IMohEnrolmentData {
  agreementHoldersName: string;
  agreementNumber: string;
  changeOfDentalProvider: boolean;
  districtArea: string;
  newEnrolment: boolean;
  nhiNumber: string;
  patientAddress: string;
  patientDateOfBirth: ISODateType;
  patientDayPhoneNumber: string;
  patientFirstName: string;
  patientGender: Gender;
  patientLastName: string;
  patientMobile: string;
  patientOrGuardianName: string;
  patientPostcode: number;
  patientSchool: string;
  patientSchoolYear: number;
  patientSignatureDate: string;
  payeeNumber: string;
  practiceName: string;
  practicePhysicalAddress: string;
  practicePostalAddress: string;
  signatureDate: ISODateType;
}

const isMohEnrolmentData = TypeGuard.interface<IMohEnrolmentData>({
  agreementHoldersName: isString,
  agreementNumber: isString,
  changeOfDentalProvider: isBoolean,
  districtArea: isString,
  newEnrolment: isBoolean,
  nhiNumber: isString,
  patientAddress: isString,
  patientDateOfBirth: isISODateType,
  patientDayPhoneNumber: isString,
  patientFirstName: isString,
  patientGender: TypeGuard.enumValue(Gender),
  patientLastName: isString,
  patientMobile: isString,
  patientOrGuardianName: isString,
  patientPostcode: isNumber,
  patientSchool: isString,
  patientSchoolYear: isNumber,
  patientSignatureDate: isString,
  payeeNumber: isString,
  practiceName: isString,
  practicePhysicalAddress: isString,
  practicePostalAddress: isString,
  signatureDate: isISODateType,
});

export const isMohEnrolmentFormRequest =
  TypeGuard.interface<IMohGenerateEnrolmentFormRequest>({
    patient: isDocRef,
    practice: isDocRef,
    data: isMohEnrolmentData,
  });

export interface IMohSendEnrolmentFormRequest {
  patient: DocumentReference<IPatient>;
  practice: DocumentReference<IPractice>;
  formPath: string;
  agreementHolderSignature: string;
  patientOrGuardianSignature: string;
  patientOrGuardianSignatureType: MohEnrolmentSignatureType;
}

export const isMohSendEnrolmentFormRequest =
  TypeGuard.interface<IMohSendEnrolmentFormRequest>({
    patient: isDocRef,
    practice: isDocRef,
    formPath: isString,
    agreementHolderSignature: isString,
    patientOrGuardianSignature: isString,
    patientOrGuardianSignatureType: TypeGuard.enumValue(
      MohEnrolmentSignatureType
    ),
  });
